import React, {useState, useEffect} from 'react'
import {getSnowflakeSummaries} from "../api/client";
import {useSelector} from "react-redux";
import {CenteredSpinner2} from "./CenteredSpinner";
import {IconFeedback} from "@seismic/mantle";

export const MeetingSnowflakeSummaryTab = () => {
    
    const [summaries, setSummaries] = useState(null);
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const selectedMeetingId = useSelector(state => state.users.selectedMeetingId);

    const cleanText = (data) => {

        if(data == null)
            return data;

        let toReturn = [];

        data.split('\n').map((d, i) => {
            let trimmed = d.trim();

            if(trimmed.startsWith("-"))
                trimmed = "•" + trimmed.substring(1).trim();

            if (trimmed !== "")
                toReturn.push(trimmed)
        });

        return toReturn.join("\n");
    }

    const loadSummaries = async () => {
        
        if(selectedMeetingId == null || selectedMeetingId === "") {
            setSummaries(null)
            return;
        }
        
        setSummaries(null)
        setLoading(true);
        try {
            let summaries = await getSnowflakeSummaries(selectedMeetingId);
            setSummaries(summaries);
        }
        catch (e) {
            console.error(e);
            setError(e);
        }
        finally {
            setLoading(false);
        }
    }
    
    useEffect(() => {
        loadSummaries();
    }, [selectedMeetingId]);
    
    return <div style={{paddingTop: "8px", display: "flex", gap: "16px"}}>
        {loading && <div style={{width: "100%", paddingTop: "24px"}}><CenteredSpinner2 message="Loading..." /></div>}
        {error && <div style={{color: "red"}}>{error}</div>}
        {summaries?.filter(a=>a.approach === "llama2-ibm" || a.approach === "turbo-16k-toms-v1")?.map(summary => <div key={summary.approach} style={{flex: 1, display: "flex", flexDirection: "column", gap: "8px", backgroundColor: "white", padding: "8px", border: "1px solid #cfd4da", borderRadius: "4px"}}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h3>{summary.approach}</h3>
                <a href={`mailto:incubation@seismic.com?subject=Feedback For ${selectedMeetingId} ${summary.approach}&body=Feedback: Good|Bad|Meh%0D%0AComments: Comments Go Here`}><IconFeedback title="Feedback" size="16" /></a>
            </div>
            <small>Cost: ${summary.additionalInfo.cost}</small>
            <h4 style={{borderTop: "1px solid #cfd4da"}}>Summary</h4>
            <div style={{whiteSpace: "pre-wrap"}}>{cleanText(summary.summary)}</div>
            <h4>Next Steps</h4>
            <div style={{whiteSpace: "pre-wrap"}}>{cleanText(summary.additionalInfo.nextSteps?.join("\n"))}</div>
            <h4>Short Summary</h4>
            <div style={{whiteSpace: "pre-wrap"}}>{cleanText(summary.additionalInfo.shortSummary)}</div>
        </div>)}
        {summaries?.length === 0 ? <div style={{padding: "8px"}}>No summaries found for this meeting. Please check in later.</div> : null}
    </div>
}